import Portfolio from "./pages/Portfolio";

const App = () => {
  return <Portfolio />;
};

export default App;